import { render, staticRenderFns } from "./DocumentVisualizer.vue?vue&type=template&id=1a2cf6bf&scoped=true"
import script from "./DocumentVisualizer.vue?vue&type=script&lang=js"
export * from "./DocumentVisualizer.vue?vue&type=script&lang=js"
import style0 from "./DocumentVisualizer.vue?vue&type=style&index=0&id=1a2cf6bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2cf6bf",
  null
  
)

export default component.exports